import EventHelperCommon from "../scheduler-event-helper/common";
import EventHelperVessel from "../scheduler-event-helper/vessel";
import EventHelperCrew from "../scheduler-event-helper/crew";

import C from "../Constants";

/**
 * 包括しているイベントを処理する。
 * 削除、分割処理を行う。
 * @param {EventModel} editedEvent
 * @param {Array<EventModel>} targetEvents
 * @param {EventStore} eventStore
 */
const processOverlappingEventsAsync = async (
  editedEvent,
  targetEvents,
  eventStore,
  displayMode
) => {
  // 重なっている、または隣接しているイベントを検索
  const overlappingOrAdjacentEvents = targetEvents.filter(event => {
    return EventHelperCommon.isOverlappingOrAdjacent(editedEvent, event);
  });

  // 追加イベントを包括しているイベントを検索
  const addedContains = overlappingOrAdjacentEvents.filter(event => {
    return EventHelperCommon.isContained(editedEvent, event);
  });
  // 追加イベントを含むイベントが存在する場合、下船中様態のイベントを削除
  for (const containtsEvent of addedContains) {
    let isSameEventType = false;
    if (displayMode === C.DISPLAY_MODE.CREWS) {
      isSameEventType = EventHelperCrew.isSameEventType(
        editedEvent,
        containtsEvent
      );
    } else {
      isSameEventType = EventHelperVessel.isSameEventType(
        editedEvent,
        containtsEvent
      );
    }

    // 同じ種類のイベントの場合は追加されたイベントを削除
    if (isSameEventType) {
      EventHelperCommon.softDelete(editedEvent);
      // 異なる場合は分割処理
    } else {
      // 追加イベントが内部包括している場合は分割処理
      if (
        containtsEvent.startDate.getTime() < editedEvent.startDate.getTime() &&
        containtsEvent.endDate.getTime() > editedEvent.endDate.getTime()
      ) {
        await _splitEventAsync(
          containtsEvent,
          eventStore,
          editedEvent.startDate,
          editedEvent.endDate
        );
      }
    }
  }

  // 追加イベントが包括しているイベントは削除
  const contains = overlappingOrAdjacentEvents.filter(event => {
    return EventHelperCommon.isContained(event, editedEvent);
  });
  for (const targetEvent of contains) {
    EventHelperCommon.softDelete(targetEvent);
  }
};

const _splitEventAsync = async (
  targetEvent,
  eventStore,
  startDate,
  endDate
) => {
  const copyEvent = await EventHelperCommon.copyEventAsync(
    targetEvent,
    eventStore
  );
  await copyEvent.setStartDate(endDate, false);
  await targetEvent.setEndDate(startDate);
};

export { processOverlappingEventsAsync };
